import { render, staticRenderFns } from "./BaaFormNavigator.vue?vue&type=template&id=79b59fea&scoped=true&"
import script from "./BaaFormNavigator.vue?vue&type=script&lang=js&"
export * from "./BaaFormNavigator.vue?vue&type=script&lang=js&"
import style0 from "./BaaFormNavigator.vue?vue&type=style&index=0&id=79b59fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b59fea",
  null
  
)

export default component.exports